export class UnableToSetListingsData extends Error {
    constructor(error: Error) {
        super();

        this.name = this.constructor.name;
        this.stack = error.stack;
        this.message = error.message;
    }
}
